import { render, staticRenderFns } from "./deliver_stock_device_num.vue?vue&type=template&id=87f937be"
import script from "./deliver_stock_device_num.vue?vue&type=script&lang=js"
export * from "./deliver_stock_device_num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports